export default __webpack_public_path__ + "static/media/cameraH1.734d189e.png";